import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ProductRoutingService {
    private url = environment.api;
    constructor(
        private http: HttpClient,
    ) { }

    create(payload: any) {
        return this.http.post(`${this.url}api/erp/routing/product`, payload);
    }

    getAll() {
        return this.http.get(`${this.url}api/erp/routing/product`);
    }

    update(id: number, payload: { productEntry: number; productSale: number }) {
        return this.http.put(`${this.url}api/erp/routing/product/${id}`, payload);
    }

    delete(id: number) {
        return this.http.delete(`${this.url}api/erp/routing/product/${id}`);
    }

    createPurchase(payload: any) {
        return this.http.post(`${this.url}api/erp/routing-purchase/product`, payload);
    }

    getAllPurchase() {
        return this.http.get(`${this.url}api/erp/routing-purchase/product`);
    }

    updatePurchase(id: number, payload: { productEntry: number; productSale: number }) {
        return this.http.put(`${this.url}api/erp/routing-purchase/product/${id}`, payload);
    }

    deletePurchase(id: number) {
        return this.http.delete(`${this.url}api/erp/routing-purchase/product/${id}`);
    }
}